import type { ReactElement } from 'react';

import styles from './spaces.module.css';
import { Button } from '../../../components/Button';
import { Link } from 'react-router-dom';

interface Props {
  icon: string;
  text: string;
  href: string;
  href2?: string;
}

const SpaceCard = ({ icon, text, href, href2 }: Props): ReactElement => (
  <a
    className={styles.card}
    target="_blank"
    rel="noreferrer"
    href={href2 ? null : href}
  >
    <img
      src={`/assets/images/icons/spaces/${icon}`}
      className="w-20 h-20 max-[899px]:w-16 max-[899px]:h-16"
    />
    <div className="flex flex-col min-[900px]:justify-center min-[900px]:items-center">
      <b className="font-bold text-medium-emphasis">Para você</b>
      <h3 className="text-primary-main text-2xl">{text}</h3>
      {href2 && (
        <div className="flex gap-2">
          <Button
            invertIcon
            tag={Link}
            to={href}
            intent="newOrange"
            text="Clinica"
            className="mx-auto -bottom-[1rem] relative w-fit"
          />
          <Button
            invertIcon
            tag={Link}
            to={href2}
            intent="newOrange"
            /* Icon={ArrowRightIcon} */
            text="Dentista"
            className="mx-auto -bottom-[1rem] relative w-fit"
          />
        </div>
      )}
    </div>
  </a>
);

export default SpaceCard;
